import React, { useState } from "react";
import PropTypes from "prop-types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Grid, IconButton, Menu, MenuItem, Button } from "@mui/material";
import lockIcon from "assets/images/lockimage.svg";
import Popover from "@mui/material/Popover";
import AlertComponent from "components/AlertComponent";

function OrganizationCard({
  title,
  isLocked,
  body,
  bodyStyle,
  border,
  // organization,
  fetchAllApiData,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = useState({
    deleteOrganizationError: false,
    deleteOrganizationSuccess: false,
    alertStatename: "",
    mesage: "",
    varient: "",
  });
  const closeAlertModel = (statename) => {
    setState((prev) => ({
      ...prev,
      [statename]: false,
    }));
    fetchAllApiData();
  };
  const openAlertModel = (statename, message, variant, alertstateName) => {
    setState((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleDeleteOrganization = () => {
    // const organizationId = organization?.id;
    // organizationService
    //   .deleteOrganization(organizationId)
    //   .then(() => {
    //     setAnchorEl(null);
    //     openAlertModel(
    //       "deleteOrganizationSuccess",
    //       "Delete Organization Successfuly",
    //       "success",
    //       "deleteOrganizationSuccess"
    //     );
    //   })
    //   .catch(() => {
    //     openAlertModel(
    //       "deleteOrganizationError",
    //       "something went Wrong !",
    //       "error",
    //       "deleteOrganizationError"
    //     );
    //   });
    setAnchorEl(null);
    openAlertModel(
      "deleteOrganizationSuccess",
      "Delete Organization temporarely disabled",
      "success",
      "deleteOrganizationSuccess"
    );
  };
  return (
    <div className="b-organization-container">
      <AlertComponent
        title={state.mesage}
        msg={state.varient}
        handleCloseAlert={() => closeAlertModel(state.alertStatename)}
        openAlert={state[state.alertStatename]}
      />
      <Grid container spacing={2} className="b-organization-container__heading">
        <Grid item className={`${bodyStyle}`}>
          <div>
            <div className={`b-organization-container__${border}`}>
              <Grid container spacing={0}>
                <Grid item xs={11}>
                  <div className="b-organization-container__grid">
                    {isLocked === "true" && (
                      <img
                        className="b-organization-container__image"
                        src={lockIcon}
                        alt=""
                      />
                    )}
                    {isLocked === "true" && (
                      <span className="b-organization-container__locked-span ">
                        {title}
                      </span>
                    )}
                    {isLocked === "false" && (
                      <span className="b-organization-container__span ">
                        {title}
                      </span>
                    )}
                  </div>
                </Grid>

                <Grid item xs={1}>
                  <div className="b-organization-container__headingSpan">
                    <IconButton
                      className="b-organization-container__more-btn-icon"
                      onClick={handleClick}
                      aria-describedby={id}
                      variant="contained"
                    >
                      {isLocked === "false" && (
                        <MoreVertIcon className="b-organization-container__moreIcon" />
                      )}
                      {isLocked === "true" && (
                        <MoreVertIcon className="b-organization-container__locked-moreIcon" />
                      )}
                    </IconButton>
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <Button
                        className="b-organization-container__delete-btn-text"
                        sx={{ p: 2 }}
                        onClick={handleDeleteOrganization}
                      >
                        Delete Organization
                      </Button>
                    </Popover>
                    {/* <Menu>
                      <MenuItem> </MenuItem>
                    </Menu> */}
                    <Menu
                      id={id}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={handleDeleteOrganization}>
                        Delete Organization
                      </MenuItem>
                    </Menu>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>

          <div className="b-organization-container__mainBody">{body}</div>
        </Grid>
      </Grid>
    </div>
  );
}

OrganizationCard.propTypes = {
  title: PropTypes.string.isRequired,
  isLocked: PropTypes.bool.isRequired,
  bodyStyle: PropTypes.string.isRequired,
  border: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.object]).isRequired,
  // organization: PropTypes.string.isRequired,
  fetchAllApiData: PropTypes.func.isRequired,
};
export default OrganizationCard;
